import React from 'react';
import { Chip, Box } from '@mui/material';
import _ from 'lodash';
import { TagItem, TagProps } from './types';
import { useTranslation } from 'react-i18next';

const Tag = ({ tagItems=[], onChange, selectedTags=[], limitTags }: TagProps) => {
  const {t} = useTranslation();
  const handleTagChange = (selectedTag: TagItem) => {
    const findSelectedTag = selectedTags.findIndex((x) => {
      return x.key.toUpperCase() === selectedTag.key.toUpperCase();
    });
    
    if (findSelectedTag !== -1) {
      const updatedSelectedTags = _.filter(
        selectedTags,
        (x) => {
          return x.key.toUpperCase() !== selectedTag.key.toUpperCase();
        }
      );
      
      onChange(updatedSelectedTags);
    } else {
      onChange([
        ...selectedTags,
        selectedTag,
      ]);
    }
  };

  const checkTagSelected = (tag: string) => {    
    return _.findIndex(selectedTags, (item) => item.key.toUpperCase() === tag.toUpperCase()) !== -1;
  };

  return (
    <Box sx={{ mr: 1, mb: { xs: 1, md: 0 } }}>
      {/* keep 0,9 until data is collected from our DB, will be limited by the query */}
      {tagItems.slice(0, limitTags || tagItems.length).map((tag) => {
        return (
          <Chip
            sx={{
              mt: 1,
              mr: 1,
              mb: { xs: 1, md: 0 }
            }}
            color='primary'
            variant={!checkTagSelected(tag.key)
              ? 'outlined'
              : undefined}
            key={tag.key}
            label={t(tag.key)}
            onClick={() => handleTagChange(tag)}
          />
        );
      })}
    </Box>
  );
};
export default Tag;